const getDefaultSetTimeout = () =>
  typeof setTimeout === 'function' ? setTimeout : null;

export const waitForDelay = (delay, setTimeoutFn = getDefaultSetTimeout()) => {
  return new Promise((resolve) => {
    if (typeof setTimeoutFn !== 'function') {
      resolve();
      return;
    }

    try {
      setTimeoutFn(resolve, delay);
    } catch (error) {
      resolve();
    }
  });
};
